import React from 'react'
import Layout from '../components/layout'
import RaisedButton from 'material-ui/RaisedButton';
import {loadSecurityQuestionsForReset, verifyAnswers, resetPin, save} from '../store'
import { browserHistory } from 'react-router'
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import {refreshActivityTimer} from '../components/timeout'
import PageviewGA from '../components/pageview-ga'

class Question extends React.Component {

    onAnswer() {
        refreshActivityTimer()
        const answer = this.refs.answer.getValue()
        this.props.onAnswer( this.props.id, answer )
    }

    render() {
        return (
            <div className="question">
                <div>{this.props.text}</div>
                <TextField name={`question_${this.props.id}`} ref="answer" hintText="Answer" onChange={() => this.onAnswer()}/>
            </div>
        )
    }
}

class Body extends React.Component {

    constructor() {
        super();
        this.state = {pin1: "", pin2: "", selected_questions: {}}
    }
    
    validatePin1Entry(e) {
        refreshActivityTimer()
        if ( isNaN(e.target.value) ) return
        let pin1 = e.target.value
        this.setState( {pin1})
    }

    validatePin2Entry(e) {
        refreshActivityTimer()
        if ( isNaN(e.target.value) ) return
        let pin2 = e.target.value
        this.setState( {pin2})
    }


    continue(e) {
        if (e) e.preventDefault()
        verifyAnswers(this.state.selected_questions)
    }

    componentDidMount() {
        if(this.refs.pin1) this.refs.pin1.focus()
    }

    onQuestionAnswered( id, answer ) {
        let selectedQuestions = this.state.selected_questions
        selectedQuestions[id] = answer
        this.setState( {selected_questions: selectedQuestions})
    }

    setupPin() {
        const pinsMatch = (this.state.pin1 === this.state.pin2) && this.state.pin1.length === 4
        const pinsDontMatch = (this.state.pin1 !== this.state.pin2) && this.state.pin1.length === 4 && this.state.pin2.length === 4

        return (
            <form>
                <div className="page-margin register-pin layout-row layout-align-center-start">
                    <div className="layout-column layout-align-center">

                        <h1>Please choose a new PIN</h1>
                        <div>
                            <input name="pin1" ref="pin1" type="password" maxLength="4" minLength="4" size="4" value={this.state.pin1} onChange={(e) => this.validatePin1Entry(e)}/>
                        </div>

                        <h1>Please re-enter your new PIN</h1>
                        <div>
                            <input name="pin2" ref="pin2" type="password" maxLength="4" minLength="4" size="4" value={this.state.pin2} onChange={(e) => this.validatePin2Entry(e)}/>
                        </div>
                        <br/>
                        { pinsDontMatch ?
                            <span className="error">The PINs must match</span>
                            : <br/>
                        }

                        <br/>
                        <RaisedButton disabled={!pinsMatch} fullWidth={true} label="RESET AND LOGIN" primary={true} onClick={() => this.resetAndLogin()}/>
                    </div>
                </div>
            </form>
        )

    }

    answerQuestions() {

        let questions = this.props.store.security_questions_for_reset.items.map( (q) => {
            return (
                <Question key={q.question_id} text={q.question_text} id={q.question_id}
                          onAnswer={(id, answer) => this.onQuestionAnswered(id, answer)}/>
            )
        })

        const allAnswered = Object.keys(this.state.selected_questions).filter( (id) => {
                return this.state.selected_questions[id] !== ""
            } ).length === this.props.store.security_questions_for_reset.items.length

        const incorrectAnswer = (this.props.store.verify_answers.http_status === 412)

        return (
            <div>
                <div className="page-margin register-questions layout-row layout-align-center-start">
                    <div className="layout-column layout-align-center">
                        <br/>
                        <div>
                            {questions}
                        </div>
                        { incorrectAnswer ?
                            <span className="error">One or more answers are incorrect. Please try again.</span>
                            : <br/>
                        }
                        <br/>
                        {this.props.store.verify_answers.show_spinner ? 
                            <div className="spinner">
                                <CircularProgress size={40} thickness={4} />
                            </div>
                            :
                            <RaisedButton id="CONTINUE" disabled={!allAnswered} fullWidth={true} label="CONTINUE" primary={true} onClick={() => this.continue()}/>
                        }<br/>
                    </div>
                </div>
            </div>

        )

    }

    resetAndLogin() {
        resetPin(this.state.pin1, this.state.selected_questions, () => {
            save( {current_user: { ...this.props.store.current_user, is_account_locked: false }})
            browserHistory.push("/latest-payslip")
        })
    }

    render() {
        if (this.props.store.verify_answers.http_status === 204) {
            return this.setupPin()
        }
        else {
            return this.answerQuestions()
        }
    }
}



export default class extends React.Component {

    componentDidMount() {
        loadSecurityQuestionsForReset()
    }

    render() {
        let sp = this.props.store.security_questions_for_reset.show_spinner 
            || this.props.store.reset_pin.show_spinner
        let errorMessage = this.props.store.reset_pin.treat_as_error ? "Error resetting your PIN" : null
        errorMessage = this.props.store.verify_answers.treat_as_error ? "Error verifying your answers" : errorMessage
        errorMessage = this.props.store.security_questions_for_reset.treat_as_error ? "Error retrieving security questions" : errorMessage

        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title="Reset PIN"
                        showAppBarActions={false}
                        {...this.props}
                        ready={ !( sp) }
                        errorMessage={errorMessage}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/reset_pin.js